module.exports = __webpack_public_path__ + "static/media/logo.00f76014.png";